export enum MarkerType {
  Circle,
  Triangle
}
